export class StandardError {
  constructor(type: StandardErrorTypes, message = '') {
    this.message = message;
    this.type = type;
  }
  type: StandardErrorTypes;
  message: string;
}

export enum StandardErrorTypes {
  INSERT = 'Failed to insert',
  UPDATE = 'Failed to update',
  CONFLICT = 'Failed to insert due to conflict',
  EXCEPTION = 'Failed due to an exception',
  NOT_FOUND = 'Failed to find result',
  BAD_REQUEST = 'Failed due to bad request',
  UNKNOWN = 'Failure Reason Unknown',
}

export interface StandardObjectResult<T> {
  isSuccessful: boolean;
  payload: T | null;
  error: StandardError | undefined;
}

export interface StandardResult {
  isSuccessful: boolean;
  error: StandardError | undefined;
}

export class StandardObjectResult<T> implements StandardObjectResult<T> {
  constructor(payload: T = null, isSuccessful: boolean = undefined, error: StandardError = undefined) {
    this.payload = payload;
    this.error = error;
    this.isSuccessful = isSuccessful || (payload ? true : false);
  }
}
export class StandardResult implements StandardResult {
  constructor(isSuccessful: boolean = false, error: StandardError = undefined) {
    this.error = error;
    this.isSuccessful = isSuccessful;
  }
}
